<div class="row">
  <div class="col-12">
    <h1>Not Found!</h1>
    <p>Oops, page is not found.</p>
  </div>
</div>